import formatDate from 'date-fns/format';

import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import prepareOperations from '../../adapters/prepareOperations';
import { ApiEndpoint } from '../../constants';
import prepareQuery from '../../helpers/prepareQuery';
import { RequestError } from '../../types';
import * as T from './types';

const DEFAULT_PAGE_SIZE = 30;

function convertDateToString(date: Date) {
  return formatDate(date, 'yyyy-MM-dd');
}

export const getOperations = createAsyncThunk<
  T.OperationThunkResult,
  T.Payload,
  { rejectValue: RequestError }
>(
  'virtualCard/getOperations/fetch',
  async (
    {
      startDate = new Date(2020, 0, 1),
      endDate = new Date(),
      pageSize = DEFAULT_PAGE_SIZE,
      pageNumber = 1,
      currentPageNumber,
    },
    { rejectWithValue }
  ) => {
    try {
      const url = ApiEndpoint.Operations;

      const query = prepareQuery({
        periodStart: convertDateToString(startDate),
        periodEnd: convertDateToString(endDate),
        // если данных ещё нет и запрашивается не первая страница,
        // то запрашиваем первую страницу размером pageSize * pageNumber
        size: currentPageNumber === 0 ? pageSize * pageNumber : pageSize,
        page: currentPageNumber === 0 ? 1 : pageNumber,
        withMarks: true,
      });
      const {
        body: { error, result: responseResult },
      } = await superagent.get(url).query(query);

      if (error) {
        throw error;
      }

      const result = prepareOperations(responseResult);

      return {
        operations: result,
        startDate: convertDateToString(startDate),
        endDate: convertDateToString(endDate),
      };
    } catch (error: any) {
      return rejectWithValue(error.response.body as RequestError);
    }
  }
);
